if (!customElements.get('product-image-slider')) {
  customElements.define(
    'product-image-slider',
    class ProductImageSlider extends HTMLElement {
      constructor() {
        super();
        this.breakpoint = 768; // Mobile breakpoint (adjust as needed)
        this.sliderInstance = null;
        this.isSliderInitialized = false;
      }

      connectedCallback() {
        this.sliderWrapper = this.querySelector('.swiper');
        this.sliderPagination = this.querySelector('.swiper-pagination');
        this.productId = this.dataset.productId;
        
        // Check if swiper is disabled via data attribute
        this.swiperDisabled = this.dataset.swiperDisable === 'true';

        // Only initialize if swiper is not disabled
        if (!this.swiperDisabled) {
          // Initialize based on screen size
          this.handleResize();

          // Listen for window resize events
          this.boundHandleResize = this.handleResize.bind(this);
          window.addEventListener('resize', this.boundHandleResize);
        }
      }

      disconnectedCallback() {
        // Remove resize listener
        window.removeEventListener('resize', this.boundHandleResize);
        
        // Destroy slider if it exists
        this.destroySlider();
      }

      handleResize() {
        // Don't initialize if swiper is disabled
        if (this.swiperDisabled) return;
        
        const isMobile = window.innerWidth < this.breakpoint;
        
        if (isMobile && !this.isSliderInitialized) {
          // Initialize slider for mobile
          this.initSlider();
        } else if (!isMobile && this.isSliderInitialized) {
          // Destroy slider for desktop
          this.destroySlider();
        }
      }

      initSlider() {
        if (!this.sliderWrapper || this.isSliderInitialized) return;

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 0,
          pagination: {
            el: this.sliderPagination,
            clickable: true,
            bulletClass: 'swiper-pagination-bullet product-image-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
          },
          effect: 'slide',
          speed: 300,
          grabCursor: true,
          allowTouchMove: true,
          loop: false,
          threshold: 2,
          watchSlidesProgress: true,
          on: {
            init: this.handleSliderInit.bind(this),
            slideChange: this.handleSlideChange.bind(this),
          },
        };

        // Initialize the slider using your theme's carousel system
        if (window.FoxTheme && window.FoxTheme.Carousel) {
          this.sliderInstance = new window.FoxTheme.Carousel(
            this.sliderWrapper, 
            this.sliderOptions,
            []
          );
          this.sliderInstance.init();
          this.isSliderInitialized = true;
        } else {
          console.warn('FoxTheme.Carousel not found, product image slider initialization failed');
        }
      }

      destroySlider() {
        if (this.sliderInstance && this.sliderInstance.slider) {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = null;
          this.isSliderInitialized = false;
        }
      }

      handleSliderInit(swiper) {
        // Fix active bullet transition on first load
        if (this.sliderPagination) {
          const activeBullet = this.sliderPagination.querySelector('.swiper-pagination-bullet-active');
          if (activeBullet) {
            activeBullet.classList.remove('swiper-pagination-bullet-active');
            activeBullet.offsetHeight; // Trigger reflow
            activeBullet.classList.add('swiper-pagination-bullet-active');
          }
        }

        // Add hover effects for mobile (touch devices)
        this.addTouchEffects();
      }

      handleSlideChange(swiper) {
        const activeIndex = swiper.activeIndex;
        // Custom logic for slide changes
      }

      addTouchEffects() {
        // Touch-specific effects can be added here
        // No hover effects needed for mobile
      }

      // Method to update slider if product images change
      updateImages(newImages) {
        if (!this.isSliderInitialized) return;

        // Destroy current slider
        this.destroySlider();

        // Update wrapper content with new images
        const wrapper = this.sliderWrapper.querySelector('.swiper-wrapper');
        wrapper.innerHTML = '';

        newImages.forEach((imageUrl, index) => {
          const slide = document.createElement('div');
          slide.className = 'swiper-slide slider-item';
          slide.innerHTML = `<img src="${imageUrl}" alt="Product image ${index + 1}" class="motion-reduce product-image">`;
          wrapper.appendChild(slide);
        });

        // Reinitialize slider if we're on mobile
        if (window.innerWidth < this.breakpoint) {
          this.initSlider();
        }
      }

      // Public method to manually refresh the slider state
      refresh() {
        this.handleResize();
      }
    }
  );
}